import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskKeyValuePairService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/taskkeyvaluepairs`;

  constructor(private http: HttpClient) { }

  save(keyValuePairs: Boo.Objects.TaskKeyValuePair[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/save`, keyValuePairs);
  }

  getByTaskIdAndKeyId(taskId: number, keyId: number): Observable<Boo.Objects.TaskKeyValuePair> {
    return this.http.get<Boo.Objects.TaskKeyValuePair>(`${this.baseUrl}/GetByTaskIdAndKeyId`, {
      params: new HttpParams()
        .set('taskId', taskId)
        .set('keyId', keyId)
    });
  }

  getByTaskId(taskId: number): Observable<Boo.Objects.TaskKeyValuePair[]> {
    return this.http.get<Boo.Objects.TaskKeyValuePair[]>(`${this.baseUrl}/getByTaskId/${taskId}`);
  }
}
